import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
} from '@angular/core';
import { CustomRateComponent } from './right-side-pannel/custom-rate/custom-rate.component';
import { CommonHelperService } from '@loup-transload-ui-app/common-services';

@Component({
  selector: 'app-rates-selection-details',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule, CustomRateComponent],
  templateUrl: './rates-selection-details.component.html',
  styleUrls: ['./rates-selection-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatesSelectionDetailsComponent {
  private readonly commonHelper = inject(CommonHelperService);
  public readonly lumberPath = 'assets/images/lumber.png';
  public readonly producePath = 'assets/images/produce.png';
  public readonly metalsPath = 'assets/images/metal.png';

  openNewTab(tabName: string) {
    switch (tabName) {
      case 'lumber':
        this.commonHelper.openInNewTab('/lumber-historical-rates');
        break;
      case 'lumberHistory':
        this.commonHelper.openInNewTab('/lumber-rates');
        break;
      case 'produce':
        this.commonHelper.openInNewTab('/produce-historical-rates');
        break;
      case 'produceHistory':
        this.commonHelper.openInNewTab('/produce-rates');
        break;
      case 'metals':
        this.commonHelper.openInNewTab('/metals-historical-rates');
        break;
      case 'metalsHistory':
        this.commonHelper.openInNewTab('/metals-rates');
        break;
      default:
        break;
    }
  }
}
